// popupGuide.js

// === HTML 템플릿 ===
const template = `
  <div
    id="popupGuide"
    style="
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.6);
      justify-content: center;
      align-items: center;
      z-index: 9999;
    "
  >
    <div
      style="
        background: white;
        padding: 28px;
        border-radius: 12px;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
        max-width: 400px;
        text-align: center;
        line-height: 1.5;
      "
    >
      <h3 id="popupGuideTitle" style="margin-bottom: 12px; font-size: 20px; font-weight: 600; color: #333;"></h3>
      <div style="text-align: left; padding: 14px">
        <p id="popupGuideMessage" style="margin-bottom: 16px; font-size: 16px; color:#424242;"></p>
      </div>
      
      <div style="display: flex; justify-content: right; gap: 8px;">
        <button
          id="popupGuideCloseBtn"
          style="padding: 8px 16px; border: none; background: #1e73e8; color: white; border-radius: 6px; cursor: pointer;"
        >
          확인
        </button>
      </div>
    </div>
  </div>
`;

// === 팝업 DOM이 없으면 삽입 ===
function ensurePopupInserted() {
  if (!document.getElementById("popupGuide")) {
    const container = document.createElement("div");
    container.innerHTML = template.trim();
    document.body.appendChild(container.firstChild);

    document
      .getElementById("popupGuideCloseBtn")
      .addEventListener("click", () => {
        document.getElementById("popupGuide").style.display = "none";
      });
  }
}

// === 팝업 표시 ===
export function showPopupGuide(title, message, url) {
  ensurePopupInserted();

  const popup = document.getElementById("popupGuide");
  const titleEl = document.getElementById("popupGuideTitle");
  const msg = document.getElementById("popupGuideMessage");

  if (popup && msg && titleEl) {
    titleEl.textContent = title || "안내";
    msg.innerHTML = message;
    popup.style.display = "flex";
  }
}

// === 팝업 차단 감지 + 안내 ===
export function popupCheck(url) {
  let pop;

  try {
    pop = window.open(url, "_blank");
    // 팝업 끄기 테스트
    // pop.close();
  } catch (e) {
    pop = null;
  }

  if (!pop || pop.closed || typeof pop.closed === "undefined") {
    const ua = navigator.userAgent.toLowerCase();
    let message = "팝업이 차단되어 시험 화면을 띄우지 못했습니다.<br/>" +
      "팝업 차단을 해제해 주세요.<br/><br/>" +
      "[팝업 차단 해제 방법]<br/>" +
      "우측 상단 두 줄 아이콘 클릭 - 설정 - 편리한 기능 선택하여 팝업 차단 해제";
    /*
    if (ua.includes("whale") || ua.includes("edg") || ua.includes("chrome")) {
      message = "주소창의 자물쇠 → 사이트 설정 → 팝업 및 리디렉션 → '허용'으로 변경하세요.";
    } else if (ua.includes("firefox")) {
      message = "주소창의 'i' 아이콘 → 권한 → 팝업 허용 또는 예외 추가하세요.";
    } else if (ua.includes("safari") && !ua.includes("chrome")) {
      message = "Safari → 설정 → 웹사이트 → 팝업 윈도우 항목에서 허용하세요.";
    }
    */

    showPopupGuide("팝업 차단 안내", message, url);
    return;
  }

  pop.focus();
}
